import router from '@/modules/securitySettings/router'
import SecuritySettingsApi from '@/modules/securitySettings/service'
import { useSecuritySettingsStore } from '@/modules/securitySettings/store'

export default {
  router,
  service: new SecuritySettingsApi(),
  store: useSecuritySettingsStore,
}
